'use client';

import { useEffect, useRef } from 'react';
import { useServerInsertedHTML } from 'next/navigation';
import { OPTIMIZELY_SCRIPT_ID, OPTIMIZELY_SCRIPT_SRC } from './constants';
import {
  ANALYTICS_NEXT_UMD_ORIGIN,
  SEGMENT_BOOTSTRAP_SCRIPT_ID,
  buildInlineSegmentBootstrap,
} from './segment-bootstrap-script';

function useOptimizelyScript() {
  const injected = useRef(false);

  useEffect(() => {
    if (injected.current) return;
    injected.current = true;

    if (document.getElementById(OPTIMIZELY_SCRIPT_ID)) return;

    const script = document.createElement('script');
    script.id = OPTIMIZELY_SCRIPT_ID;
    script.src = OPTIMIZELY_SCRIPT_SRC;
    script.async = true;
    document.head.appendChild(script);
  }, []);
}

export function SegmentBootstrappedOptimizelyScript({ segmentKey }: { segmentKey: string }) {
  const inserted = useRef(false);
  const inlineScript = buildInlineSegmentBootstrap(segmentKey);

  useServerInsertedHTML(() => {
    if (inserted.current) return null;
    inserted.current = true;
    return (
      <>
        <link href={ANALYTICS_NEXT_UMD_ORIGIN} rel="dns-prefetch" />
        <link crossOrigin="" href={ANALYTICS_NEXT_UMD_ORIGIN} rel="preconnect" />
        <link as="script" href={OPTIMIZELY_SCRIPT_SRC} rel="preload" />
        <script
          // eslint-disable-next-line benzinga/no-unsanitized-innerhtml
          dangerouslySetInnerHTML={{ __html: inlineScript }}
          id={SEGMENT_BOOTSTRAP_SCRIPT_ID}
        />
      </>
    );
  });

  useOptimizelyScript();

  return null;
}
